/*
  英语
*/
export default {
  promptText: {
    msg1: 'success',
    msg2: 'warning',
    msg3: 'error',
    msg4: 'Validation succeeded',
    msg5: 'Please Add Store First',
    msg6: 'Sorry, order weight cannot exceed 30kg',
    msg7: 'The current product stock:',
    msg8: 'Please set the bill address first or pay by other means',
    msg9: 'Cannot deliver to the address from this warehouse, please change shipping address or warehouse',
    msg10: 'Please add address information first!',
    msg11: 'Failed, reached credit limit!',
    msg12: 'Please add shipping address!', // ？在哪里加
    msg13: 'Please select a shipping address!',
    msg14: 'Please enter your vaild email', // ？在哪里加  ❌
    msg15: 'The email has been registered already',
    msg16: 'Enter promo code',
    msg17: 'Item information missing', // ？在哪里出现报错，什么原因 （找不到商品信息）
    msg18: 'Please enter qty', // ？在哪里界面出现 请选择要添加进购物车的商品
    msg19: 'Shopping Bag added successfully',
    msg20: 'Failed to add shopping Bag', // ？为什么失败  在后端报错，在后端找原因
    msg21: 'Added To Favorite Item Successfully',
    msg22: 'Country Code Error', // 增加地址时的电话区号有误
    msg23: 'Change address successfully!',
    msg24: 'Please give your mark frist', // 商品评论的星星不能为空
    msg25: 'Email verified, please reset your password',
    msg26: 'Email required', // 忘记密码时输入的邮箱
    msg27: 'Password has reset, please login again',
    msg28: 'Verification Code Sent',
    msg29: 'Please input your Email and Full Name first',
    msg30: 'Incorrect Verification Code.', // 验证码有误
    msg31: 'Thanks for your submission!',
    msg32: 'Register success!',
    msg33: 'Up to',
    msg34: 'Incorrect E-mail/password!',
    msg35: 'Please enter a number greater than the start number!', // 优化
    msg36: 'Image cannot exceed 5MB', // 以图搜图
    msg37: "Tracking Number can't be empty", // ❌
    msg38: "kkOrderId can't be empty", // ❌
    msg39: "shipping carrier can't be empty", // ❌
    msg40: 'Delete address successfully',
    msg41: 'Please add the receiving address first',
    msg42: "Please choose your store's platform at first",
    msg43: 'Save store setting successfully',
    msg44: 'Input is too long', // 标题过长
    msg45: 'The compare at price must be higher than the suggested price',
    msg46: 'platform required',
    msg47: 'store required',
    msg48: 'Please input your phone number and Full Name first',
    msg49: 'Phone number required', // 忘记密码时输入的手机号
    msg50: 'Please check the terms of service at the bottom'
  }
}
